
export const lightTheme = {
  name: 'light',
  colors: {
    primary: '#6366f1',
    primaryHover: '#4f46e5',
    primaryLight: '#eef2ff',
    secondary: '#64748b',
    secondaryHover: '#475569',
    background: '#f8fafc',
    backgroundSecondary: '#f1f5f9',
    backgroundTertiary: '#e2e8f0',
    text: '#1e293b',
    textSecondary: '#64748b',
    textTertiary: '#94a3b8',
    border: '#e2e8f0',
    borderLight: '#f8fafc',
    error: '#ef4444',
    errorLight: '#fef2f2',
    success: '#10b981',
    successLight: '#ecfdf5',
    warning: '#f59e0b',
    warningLight: '#fffbeb',
    info: '#0ea5e9',
    infoLight: '#f0f9ff',
    cardBg: '#ffffff',
    inputBg: '#ffffff',
    sidebarBg: '#ffffff',
    headerBg: '#ffffff',
    overlayBg: 'rgba(15, 23, 42, 0.5)',
    authPageBg: '#f0f4ff',
    authToggleBg: 'rgba(255,255,255,0.8)',
    authToggleIcon: '#4f46e5',
  },
  shadows: {
    xs: '0 1px 2px 0 rgba(15, 23, 42, 0.04)',
    sm: '0 1px 3px 0 rgba(15, 23, 42, 0.08), 0 1px 2px 0 rgba(15, 23, 42, 0.04)',
    md: '0 4px 6px -1px rgba(15, 23, 42, 0.08), 0 2px 4px -1px rgba(15, 23, 42, 0.04)',
    lg: '0 10px 15px -3px rgba(15, 23, 42, 0.08), 0 4px 6px -2px rgba(15, 23, 42, 0.04)',
    xl: '0 20px 25px -5px rgba(15, 23, 42, 0.1), 0 10px 10px -5px rgba(15, 23, 42, 0.04)',
    '2xl': '0 25px 50px -12px rgba(15, 23, 42, 0.18)',
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    '2xl': '48px',
  },
  borderRadius: {
    sm: '4px',
    md: '8px',
    lg: '12px',
    xl: '16px',
    full: '9999px',
  },
};

export const darkTheme = {
  name: 'dark',
  colors: {
    primary: '#818cf8',
    primaryHover: '#6366f1',
    primaryLight: '#312e81',
    secondary: '#94a3b8',
    secondaryHover: '#cbd5e1',
    background: '#0f172a',
    backgroundSecondary: '#1e293b',
    backgroundTertiary: '#334155',
    text: '#f1f5f9',
    textSecondary: '#94a3b8',
    textTertiary: '#64748b',
    border: '#334155',
    borderLight: '#1e293b',
    error: '#f87171',
    errorLight: '#450a0a',
    success: '#34d399',
    successLight: '#022c22',
    warning: '#fbbf24',
    warningLight: '#451a03',
    info: '#38bdf8',
    infoLight: '#082f49',
    cardBg: '#1e293b',
    inputBg: '#0f172a',
    sidebarBg: '#1e293b',
    headerBg: '#1e293b',
    overlayBg: 'rgba(0, 0, 0, 0.7)',
    authPageBg: '#0f172a',
    authToggleBg: 'rgba(255,255,255,0.08)',
    authToggleIcon: '#c7d2fe',
  },
  shadows: {
    xs: '0 1px 2px 0 rgba(0, 0, 0, 0.3)',
    sm: '0 1px 3px 0 rgba(0, 0, 0, 0.4), 0 1px 2px 0 rgba(0, 0, 0, 0.3)',
    md: '0 4px 6px -1px rgba(0, 0, 0, 0.5), 0 2px 4px -1px rgba(0, 0, 0, 0.4)',
    lg: '0 10px 15px -3px rgba(0, 0, 0, 0.6), 0 4px 6px -2px rgba(0, 0, 0, 0.5)',
    xl: '0 20px 25px -5px rgba(0, 0, 0, 0.6), 0 10px 10px -5px rgba(0, 0, 0, 0.55)',
    '2xl': '0 25px 50px -12px rgba(0, 0, 0, 0.75)',
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    '2xl': '48px',
  },
  borderRadius: {
    sm: '4px',
    md: '8px',
    lg: '12px',
    xl: '16px',
    full: '9999px',
  },
};
